import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { sub } from 'date-fns';

import { DatePicker, Loader } from '@smartplatform/ui';
import { formatDateStr } from '../../../utils';
import { formatProtocolTime } from './store';

@inject('store') @observer
export default class DateSelect extends React.Component {

	constructor(props) {
		super(props);
		this.store = props.store;
	}
	
	render() {
		const { date, confError, protocols, searching } = this.store;
		
		return <div className="protocols block">
			<div className="block">Интеграция с конгресс-системой</div>
			<div className="date-select">
				<DatePicker
					value={date}
					onChange={this.store.onDateChange}
				/>
				{/*<Button className="btn-primary btn-sm" onClick={this.store.checkDate}>Поиск протоколов</Button>*/}
			</div>
			<div className="conf-result">
				{confError && <div className="error">{confError}</div>}
				{searching && <div><Loader size={18} /> Поиск протокололв...</div>}
				{(!searching && protocols.length > 0) && <div className="status">
					<div>
						Найдено протоколов: {protocols.length}{' '}
						({formatProtocolTime(protocols[0].start)} - {formatProtocolTime(protocols[protocols.length - 1].end)})
					</div>
				</div>}
			</div>
		</div>;
	}
}

